$(document).ready(function() {
    var currentTime = new Date();
    var currentDay = currentTime.getDay();
    var currentHour = currentTime.getHours();
    var currentMinutes = currentTime.getMinutes();
    // Pracovní doba: 8:00 - 16:30
    var openingTime = 8 * 60;
    var closingTime = 16 * 60 + 30;
    var currentMinutesSinceMidnight = currentHour * 60 + currentMinutes;
    if (currentDay >= 1 && currentDay <= 5 && currentMinutesSinceMidnight >= openingTime && currentMinutesSinceMidnight <= closingTime) {
        $('.openHours').addClass('open');
    } else {
        $('.openHours').addClass('closed');
    }
});